import { SimpleGrid, Box, Text } from '@chakra-ui/react';
import ProfileCard from '../districtProfile/ProfileCard'
import { PartyChart, RaceChart, AgeChart } from '../analyticsMap/charts/DistributionCharts'
import type { ListOverview } from '../../types/contactList'
import type { DashboardData } from '../../types/analyticsMap'

export function DemographicsPanel({ overview }: { overview: ListOverview }) {
  const data: DashboardData = {
    totalContacts: overview.memberCount,
    ideologyDistribution: overview.ideologyDistribution,
    turnoutDistribution: overview.turnoutDistribution,
    partyBreakdown: overview.partyBreakdown,
    raceBreakdown: overview.raceBreakdown,
    ageDistribution: overview.ageDistribution,
  }
  return (
    <ProfileCard eyebrow="Demographics" title="Composition">
      <SimpleGrid columns={{ base: 1, md: 3 }} gap={6} mt={3}>
        <Box><Text fontSize="sm" fontWeight="medium" mb={2}>Party</Text><PartyChart data={data} /></Box>
        <Box><Text fontSize="sm" fontWeight="medium" mb={2}>Race / ethnicity</Text><RaceChart data={data} /></Box>
        <Box><Text fontSize="sm" fontWeight="medium" mb={2}>Age</Text><AgeChart data={data} /></Box>
      </SimpleGrid>
    </ProfileCard>
  );
}
